import channelsPayload from './channelsPayload';
export default channelsPayload;
